import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIphone = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.25 19.25h-6.5a2 2 0 0 1-2-2V6.75a2 2 0 0 1 2-2h6.5a2 2 0 0 1 2 2v10.5a2 2 0 0 1-2 2M11.75 16.75h.5"
    />
  </svg>
);
export default SvgIphone;
